import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Home from './Home';

const CITY_MAP: Record<string, { cn: string; en: string }> = {
  frankfurt: { cn: '法兰克福', en: 'Frankfurt' },
  nuremberg: { cn: '纽伦堡', en: 'Nuremberg' },
  berlin: { cn: '柏林', en: 'Berlin' },
  munich: { cn: '慕尼黑', en: 'Munich' },
  cologne: { cn: '科隆', en: 'Cologne' },
  hamburg: { cn: '汉堡', en: 'Hamburg' },
  hanover: { cn: '汉诺威', en: 'Hanover' },
  stuttgart: { cn: '斯图加特', en: 'Stuttgart' },
  leipzig: { cn: '莱比锡', en: 'Leipzig' },
  dusseldorf: { cn: '杜塞尔多夫', en: 'Düsseldorf' }
};

const City: React.FC = () => {
  const { slug = '' } = useParams<{ slug: string }>();
  const city = CITY_MAP[slug.toLowerCase()];

  if (!city) {
    // 未匹配到城市，直接复用首页布局
    return <Home />;
  }

  const title = `${city.cn}展会翻译｜${city.cn}中文翻译｜按产品背景指派中英德译员`;
  const description = `在${city.cn}提供展会翻译、中文翻译、代参展与现场协助服务。可按您的产品/技术背景匹配中英德译员与协助人员，支持机械、电子、医疗、化工、消费品等行业。`;
  const keywords = `${city.cn}翻译,${city.cn}展会翻译,${city.cn}中文翻译,${city.en} interpreter,${city.en} translation,德国展会翻译,按产品背景指派翻译`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={`https://decn-exhibition.top/city/${slug}`} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Helmet>
      <Home />
    </>
  );
};

export default City;


